import React from 'react'
import { IParticipant } from '../../store/participant/interfaces'
import { genderSymbols } from '../../utils'

const SiblingData = (props: { participant: IParticipant }) => {
  return (
    <ul>
      {props.participant.siblings.map((sibling, key) => (
        <li key={key}>
          {sibling.first_name} {genderSymbols[sibling.gender]} ({' '}
          {sibling.date_of_birth} )
          {sibling.disabled && (
            <ul>
              <li>
                <small>
                  <strong>Behinderung / Beeinträchtigung: </strong>
                  {sibling.disabled}
                </small>
              </li>
            </ul>
          )}
        </li>
      ))}
    </ul>
  )
}

export default SiblingData
